import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-payment-option',
  templateUrl: './payment-option.component.html',
  styleUrls: ['./payment-option.component.scss']
})
export class AppPaymentOptionComponent implements OnInit {
  paymentType: string = 'net-bank';
  uPIId = new UntypedFormControl('', Validators.pattern(new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}')));

  constructor(
    private dialogRef: MatDialogRef<AppPaymentOptionComponent>,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
  }
  changeType(type) {
    this.paymentType = type
  }
  confirm() {
    let data: any = {
      type: this.paymentType
    }
    if (this.paymentType === 'upi') {
      if (this.uPIId.value) {
        if (this.uPIId.invalid) {
          this.alertService.error({ title: 'Please provide a valid UPI ID' })
          return;
        } else {
          data.id = this.uPIId.value;
        }
      } else {
        this.alertService.error({ title: 'UPI Id is required!!!' })
        return;
      }
    }
    this.dialogRef.close(data);
  }
  closeDialog() {
    this.dialogRef.close()
  }
}
